import React from 'react';

import get from 'lodash/get';

import { Grid, Stack, ToggleButton } from '@gogame/components';
import {
  FormField,
  useSiblingFieldName,
  withFormFieldGroupFormField,
} from '@gogame/form';

import {
  GENERAL,
  AFFECTED_LEVEL,
  SECONDARY_AFFECTED_LEVEL,
} from 'scenes/SmartRules/SmartRuleForm/General';
import { loadMetrics, loadOperators } from 'scenes/SmartRules/sources/fields';

import {
  CONDITION_TYPE,
  METRIC,
  OPERATOR,
  CALCULATION_TYPE,
  VALUE,
  PERCENTILE,
  WEIGHTED_AVERAGE,
} from './constants';
import { dynamicConditionValidationSchema } from './schemas';

export const DynamicCondition = withFormFieldGroupFormField({
  validationSchema: dynamicConditionValidationSchema,
})(({ name, value, formik }) => {
  const getSiblingFieldName = useSiblingFieldName();

  const { [METRIC]: metricId, [CALCULATION_TYPE]: calculationTypeId } = value;

  const { [METRIC]: metric } = get(formik.hierarchyState, name) || {};

  const calculationTypePercentile = calculationTypeId === PERCENTILE;

  const handleChangeMetric = React.useCallback(
    ({ target: { value } }) => {
      const { defaultOperator } =
        metric?.data?.find(({ id }) => id === value) || {};
      formik.setFieldValue(getSiblingFieldName(OPERATOR), defaultOperator);
    },
    [metric]
  );

  const validationValue = React.useCallback(
    (value) => {
      if (calculationTypePercentile && !value) {
        return 'Value is required';
      }
    },
    [calculationTypePercentile]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={4}>
        <FormField.Select
          label={'Metric'}
          name={METRIC}
          source={loadMetrics}
          onChange={handleChangeMetric}
          groupBy={'category'}
          depends={[
            `${GENERAL}.${AFFECTED_LEVEL}`,
            `${GENERAL}.${SECONDARY_AFFECTED_LEVEL}`,
            getSiblingFieldName(CONDITION_TYPE),
          ]}
          required={true}
          lazy={true}
          padding={'0'}
        />
      </Grid>
      <Grid item xs={2}>
        <FormField.Select
          label={'Operator'}
          name={OPERATOR}
          source={loadOperators}
          depends={[
            `${GENERAL}.${AFFECTED_LEVEL}`,
            `${GENERAL}.${SECONDARY_AFFECTED_LEVEL}`,
            getSiblingFieldName(METRIC),
            getSiblingFieldName(CONDITION_TYPE),
          ]}
          active={Boolean(metricId)}
          required={true}
          lazy={true}
          padding={0}
        />
      </Grid>
      <Grid item xs={4}>
        <FormField.ToggleButtonGroup
          name={CALCULATION_TYPE}
          enforceValue={true}
          padding={'0'}
          fullWidth={true}
        >
          <ToggleButton value={PERCENTILE}>Percentile</ToggleButton>
          <ToggleButton value={WEIGHTED_AVERAGE}>Weighted avg.</ToggleButton>
        </FormField.ToggleButtonGroup>
      </Grid>
      <Grid item xs={2}>
        {calculationTypePercentile ? (
          <Stack direction={'row'} spacing={1} alignItems={'baseline'}>
            <FormField.TextField
              label={'Value'}
              name={VALUE}
              type={'percent'}
              validate={validationValue}
              required={true}
              padding={'0'}
            />
          </Stack>
        ) : null}
      </Grid>
    </Grid>
  );
});
